<template>
  <el-container>
        <el-form ref="form" :model="form" label-width="250px">


          <el-form-item label="资产名称">
            <el-input v-model="form.propertyName"></el-input>
          </el-form-item>




        <!-- 需要Tree来渲染 -->
        <el-form-item label="资产状态">
          <el-select v-model="form.state" placeholder="是否为资产状态">
            <el-option label="进行中" :value="1"></el-option>
            <el-option label="待审核" :value="2"></el-option>
            <el-option label="已完成" :value="3"></el-option>
            <el-option label="已驳回" :value="4"></el-option>
            <el-option label="已终止" :value="5"></el-option>
          </el-select>
        </el-form-item>


       <el-form-item label="上传人">
          <el-input v-model="form.upUser" :value="form.upUserId">
                      <el-button
                        size="mini"
                         style="padding-right:10px"
                         slot="suffix"
                         type="text"
                        @click="dialogUpUser = true">选择</el-button></el-input>
                        <el-dialog title="请选择使用者"
                        append-to-body
                        :visible.sync="dialogUpUser" width="25%">
                        <el-input
                          placeholder="输入关键字进行过滤"
                          v-model="filterText">
                        </el-input>
                          <el-tree
                            class ="TreeBlock"
                            :data="UpUserData"
                            :filter-node-method="filterNode"
                            node-key="id"
                            @node-click="TreeUpUserClick"
                            ref="tree"
                            :props="defaultProps"
                            default-expand-all:false
                            :expand-on-click-node="false">
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                              <span>{{ node.label }}</span>
                            </span>
                          </el-tree>
                          <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogUpUser = false">取 消</el-button>
                            <el-button type="primary" @click="dialogUpUser = false;">确 定</el-button>
                          </div>
                        </el-dialog>
       </el-form-item>





        <!-- 单位人员树 -->
        <el-form-item label="使用者">
           <el-input v-model="form.user" :value="User">
                       <el-button
                         size="mini"
                          style="padding-right:10px"
                          slot="suffix"
                          type="text"
                         @click="dialogUser = true">选择</el-button> </el-input>
                         <el-dialog title="请选择使用者"
                         append-to-body
                         :visible.sync="dialogUser" width="25%">
                         <el-input
                           placeholder="输入关键字进行过滤"
                           v-model="filterText">
                         </el-input>

                           <el-tree
                             class ="TreeBlock"
                             :data="UserData"
                             :filter-node-method="filterNode"
                             node-key="id"
                             @node-click="TreeUserClick"
                             ref="tree"
                             :props="defaultProps"
                             default-expand-all:false
                             :expand-on-click-node="false">
                             <span class="custom-tree-node" slot-scope="{ node, data }">
                               <span>{{ node.label }}</span>
                             </span>
                           </el-tree>
                           <div slot="footer" class="dialog-footer">
                             <el-button @click="dialogUser = false">取 消</el-button>
                             <el-button type="primary" @click="dialogUser = false;">确 定</el-button>
                           </div>
                         </el-dialog>
        </el-form-item>




        <el-form-item label="使用部门">
          <el-select
          v-model="form.useDept"
          :value="VownerDeptId"
          placeholder="请选择使用部门">
           <el-option
           v-for="i in DName"
           :key="i.departmentId"
           :label="i.departmentName"
           :value="i.departmentId">
           </el-option>
          </el-select>
        </el-form-item>


          <el-form-item label="资产固定编码">
            <el-input v-model="form.propertyCode" placeholder="输入资产固定编码"></el-input>
          </el-form-item>


          <el-form-item label="资产类别">
            <el-input v-model="form.propertyType" :value="id">
              <!-- <el-input v-model="form.propertyTypeId" :value="id"> -->
                <el-button
                  size="mini"
                   style="padding-right:10px"
                   slot="suffix"
                   type="text"
                  @click="dialogPropertyTypeId = true">选择</el-button> </el-input>
                  <el-dialog title="选择资产类别"
                  append-to-body
                  :visible.sync="dialogPropertyTypeId" width="25%">

                  <el-input
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
                  </el-input>
                    <el-tree
                      class ="TreeBlock"
                      :data="data"
                      :filter-node-method="filterNode"
                      node-key="id"
                      @node-click="TreePropertyClick"
                      ref="tree"
                      :props="defaultProps"
                      default-expand-all:false
                      :expand-on-click-node="false">
                      <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>

                      </span>
                    </el-tree>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="dialogPropertyTypeId = false">取 消</el-button>
                      <el-button type="primary" @click="dialogPropertyTypeId = false;">确 定</el-button>
                    </div>
                  </el-dialog>

          </el-form-item>

          <el-form-item label="存放区域">
            <el-input v-model="form.placeName" :value="PlaceId">
                <el-button
                  size="mini"
                   style="padding-right:10px"
                   slot="suffix"
                   type="text"
                  @click="dialogPlace = true">选择</el-button> </el-input>
                  <el-dialog title="选择存放区域"
                  append-to-body
                  :visible.sync="dialogPlace" width="25%">
                    <el-input
                      placeholder="输入关键字进行过滤"
                      v-model="filterText">
                    </el-input>
                    <el-tree
                      class ="TreeBlock"
                      :data="PlaceData"
                      :filter-node-method="filterNode"
                      node-key="id"
                      @node-click="TreePlaceClick"
                      ref="tree"
                      :props="defaultProps"
                      default-expand-all:false
                      :expand-on-click-node="false">
                      <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>

                      </span>
                    </el-tree>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="dialogPlace = false">取 消</el-button>
                      <el-button type="primary" @click="dialogPlace = false;">确 定</el-button>
                    </div>
                  </el-dialog>


          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">立即修改</el-button>
          </el-form-item>
        </el-form>


        </el-container>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'DetectDataEdit',
     data () {
			 // 存入资产类别的数据
       const data = [{
               id: 1,
               label: '一级 1',
               children: [{
                 id: 4,
                 label: '二级 1-1',
                 children: [{
                   id: 9,
                   label: '三级 1-1-1'
                 }, {
                   id: 10,
                   label: '三级 1-1-2'
                 }]
               }]
             }];

				// 存入区域信息的数据
        const PlaceData = [{
                id: 1,
                label: '一级 1',
                children: [{
                  id: 4,
                  label: '二级 1-1',
                  children: [{
                    id: 9,
                    label: '三级 1-1-1'
                  }, {
                    id: 10,
                    label: '三级 1-1-2'
                  }]
                }]
              }];
       return {
		  // 存入前端搜索的数据
          filterText: '',
		  // 资产类别的id
          id:'',
		  // 选中区域Id
          PlaceId:'',
		  // 选中使用人的名称
          User:'',
		  // dialogUpUser里面visible属性需要的变量，当它为false隐藏，为ture则显示弹框
          dialogUpUser:false,
		  // 所有者部门Id
          VownerDeptId:'',
		  // 管理员的部门Id
          VmanagerDeptId:'',

		  // 存入管理人数据
          ManagerUser:'',
            defaultProps: {
                     children: 'children',
                     label: 'label'
                   },
		   // 将data的树Json化
           data: JSON.parse(JSON.stringify(data)),
		   // 将PlaceData的树Json化
           PlaceData: JSON.parse(JSON.stringify(PlaceData)),
		   // 存入上传人的数据
           UpUserData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],
		   // 存入管理人的数据
           MangerData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],
		   // 存入使用者的数据
           UserData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],
           defaultProps: {
                    children: 'children',
                    label: 'label'
                  },
		  // dialogUser里面visible属性需要的变量，当它为false隐藏，为ture则显示弹框
           dialogUser:false,
		   // dialogPropertyTypeId里面visible属性需要的变量，当它为false隐藏，为ture则显示弹框
           dialogPropertyTypeId:false,
		   // dialogManager里面visible属性需要的变量，当它为false隐藏，为ture则显示弹框
           dialogManager:false,
		   // dialogPlace里面visible属性需要的变量，当它为false隐藏，为ture则显示弹框
           dialogPlace:false,
		   // 存入部门数据
           DName:[{
             departmentId:'',
             departmentName:'',
           }],
		   // 存入单位数据
           DUnit:[{
             unitName:'',
             unitId:'',
           }],
		   // 存入资产所有数据的字段
              form: {
                      createDate:'',
                      epc:'',
                      supplier:'',
                       del:'',
                       holdPlace:'',
                       managerDeptId:'',
                       managerDeptName:'',
                       managerId:'',
                       managerName:'',
                       mgrName:'',
                       outProperty:'',
                       ownerDeptId:'',
                       ownerId:'',
                       placeId:'',
                       propertyCode:'',
                       propertyId:'',
                       propertyModel:'',
                       propertyName:'',
                       propertyRfid:'',
                       propertySpecification:'',
                       propertyState:'',
                       propertyType:'',
                       propertyTypeId:'',
                       unitId:'',
                       unitName:'',
                       usedDeptName:'',
                       updateDate:'',
                       usedName:'',

                       upUser:'',
                       upUserId:'',
                       useDeptId:'',
                       userId:'',
                       detailld:'',
                       gainDate:'',
                       state:'',

                    }
        };
     },
     created:function() {
		// 首先是当页面加载的时候自动渲染这些数据	
			 
		// 表格里面的数据
       this.showData();
	   // 查询条件里面的数据预加载    区域信息
       this.showPlaceData();
	   // 查询条件里面的数据预加载    部门信息
       this.showDepartmentData();
	   // 查询条件里面的数据预加载    单位信息
       this.showUnitData();
	   // 查询条件里面的数据预加载    人员信息
       this.showMData();

     },


     watch: {
		 // 树状结构的显示核心
           filterText(val) {
             this.$refs.tree.filter(val);
           }
         },
     methods: {
		 
	// 获取需要修改的清查数据
      showIndexData(val){
          this.form = val
					console.log(this.form)
        },
	// 获取上传人信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是上传人ID	
      TreeUpUserClick(data){
        this.form.upUserId = data.realId
        this.form.upUser = data.label
      },
	// 获取资产类别信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是资产类别ID	
      TreePropertyClick(data){
            this.id = data.id
            this.form.propertyType = data.label
      },
	// 获取区域信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是区域ID	
        TreePlaceClick(data){
            this.PlaceId = data.id
            this.form.holdPlace = data.label
        },
	// 获取管理人信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是管理人ID	
        TreeMangerClick(data){
            this.ManagerUser = data.realId
            this.form.managerName = data.label

        },

	// 获取使用人信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是使用人ID	
        TreeUserClick(data){
            this.User = data.realId
            this.form.usedName = data.label
        },



        filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
              },




		// 获取所有需要修改的数据进行上传，上传修改功能，并将数据刷新
          onSubmit() {
            this.form.placeId = this.PlaceId
            this.form.propertyTypeId = this.id
            this.form.userId = this.User
            this.form.outProperty = parseInt(this.form.outProperty)
            this.form.propertyState = parseInt(this.form.propertyState)
            var params = this.form

            var authorization = Cookies.get("Authorization");

             this.axios({
                 method: 'POST',
                 url: '/detect/edit',
                 data:params,
                 header:{
                  'Authorization':authorization,
                 	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                 	}
               }).then((resp)=>{
                 this.open2('修改成功')
                this.$parent.$parent.$parent.$parent.$parent.showData()
                this.$parent.$parent.$parent.$parent.$parent.dialogFormEdit = false

               })
          },

          open2(val) {
                  this.$message({
                    message: val,
                    type: 'success'
                  });
                },


		// 请求小杜接口/public/getCanHandleDepartmentList获取部门信息然后将数据传给DName在114行
          showDepartmentData(){
           var authorization = Cookies.get("Authorization");
           var params = {
             currentPage: 1,
             pageSize: 5,
           }
            this.axios({
                method: 'GET',
                url: '/public/getCanHandleDepartmentList',
                params:params,
                header:{
                 'Authorization':authorization,
                	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                	}
              }).then((resp)=>{
               this.DName = resp.data.data;
              })
          },


		  // 请求小杜接口/public/getCanWatchUnit获取单位信息然后将数据传给DUnit在186行
          showPlaceData(){
           var authorization = Cookies.get("Authorization");
           var params = {
             currentPage: 1,
             pageSize: 5,
           }
            this.axios({
                method: 'GET',
                url: '/public/getTree',

                header:{
                 'Authorization':authorization,
                	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                	}
              }).then((resp)=>{
               this.PlaceData=resp.data.data;
              })
          },





			// 请求小杜接口/public/getUnitTree获取人员信息然后将数据传给UpUserData和MangerData或UserData分别在43和85行
            showMData(){
             var authorization = Cookies.get("Authorization");
              this.axios({
                  method: 'GET',
                  url: '/public/getUnitTree',
                  header:{
                   'Authorization':authorization,
                  	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                  	}
                }).then((resp)=>{
                 // var arr = new Array(resp.data.data) ;
                 this.UpUserData = resp.data.data;
                 this.MangerData=resp.data.data;
                 this.UserData = resp.data.data;


                })
            },




			// 获取资产类别数据
            showData(){
             var authorization = Cookies.get("Authorization");

              this.axios({
                  method: 'GET',
                  url: '/public/getPropertySortTree',
                  header:{
                   'Authorization':authorization,
                  	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                  	}
                }).then((resp)=>{
                 this.data=resp.data.data;
				 
                })
            },

	
		  // 获取单位信息数据
          showUnitData(){
           var authorization = Cookies.get("Authorization");
           var params = {
             currentPage: 1,
             pageSize: 5,
           }
            this.axios({
                method: 'GET',
                url: '/public/getCanWatchUnit',
                params:params,
                header:{
                 'Authorization':authorization,
                	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                	}
              }).then((resp)=>{
               this.DUnit = resp.data.data;
              })
          },

     }
   }
</script>

<style>
  .Tree{
    width: 75%;
    border-style: solid;
    /* margin-top: 2%; */
    border-width: 3px;
    border-radius: 20px;
    border-color: #33CCFF;
  }
  .TreeBlock{
    margin-top: 1.5%;
    margin-left: 1%;
    margin-right: 1%;
    margin-bottom: 1%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Detect/DetectDataEdit.vue